import {
  DELETE_USER_FAILURE,
  DELETE_USER_GROUP_FAILURE,
  DELETE_USER_GROUP_REQUEST,
  DELETE_USER_GROUP_SUCCESS,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  FETCH_CURRENT_USER_FAILURE,
  FETCH_CURRENT_USER_REQUEST,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_GROUP_FAILURE,
  FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE,
  FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS,
  FETCH_USER_GROUP_PERM_OBJECT_REQUEST,
  FETCH_USER_GROUP_REQUEST,
  FETCH_USER_GROUP_SUCCESS,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  SAVE_AVATAR_FAILURE,
  SAVE_AVATAR_REQUEST,
  SAVE_AVATAR_SUCCESS,
  SAVE_PERSONAL_DETAILS_FAILURE,
  SAVE_PERSONAL_DETAILS_REQUEST,
  SAVE_PERSONAL_DETAILS_SUCCESS,
  SAVE_SECURITY_DETAILS_FAILURE,
  SAVE_SECURITY_DETAILS_REQUEST,
  SAVE_SECURITY_DETAILS_SUCCESS,
  SAVE_USER_FAILURE,
  SAVE_USER_GROUP_FAILURE,
  SAVE_USER_GROUP_REQUEST,
  SAVE_USER_GROUP_SUCCESS,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
} from './types';

const INITIAL_STATE = {
  userGroups: [],
  userGroupLoading: false,
  user: null,
  users: [],
  userGroupObjects: {},
  currentUser: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_GROUP_REQUEST:
      return {
        ...state,
        userGroupLoading: true,
        error: null,
      };

    case FETCH_USER_GROUP_SUCCESS:
      return {
        ...state,
        userGroupLoading: false,
        userGroups: action.payload,
      };

    case FETCH_USER_GROUP_FAILURE:
      return {
        ...state,
        userGroupLoading: false,
        error: action.payload.error,
        userGroups: [],
      };

    // TODO: to be removed
    case FETCH_USER_GROUP_PERM_OBJECT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        userGroupObjects: action.payload,
      };

    case FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        userGroupObjects: {},
      };
    //

    case DELETE_USER_GROUP_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_USER_GROUP_SUCCESS:
      return {
        ...state,
      };

    case DELETE_USER_GROUP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case FETCH_CURRENT_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
      };

    case FETCH_CURRENT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
        currentUser: null,
      };

    case SAVE_PERSONAL_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_PERSONAL_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case SAVE_SECURITY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_SECURITY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_SECURITY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case SAVE_AVATAR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_AVATAR_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_AVATAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case SAVE_USER_GROUP_REQUEST:
      return {
        ...state,
        userGroupLoading: true,
        error: null,
      };
    case SAVE_USER_GROUP_SUCCESS:
      return {
        ...state,
        userGroupLoading: false,
      };
    case SAVE_USER_GROUP_FAILURE:
      return {
        ...state,
        userGroupLoading: false,
        error: action.payload.error,
      };
    case SAVE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        users: [],
      };

    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };

    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        user: null,
      };

    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
